import { useIsMobile } from 'pricing-pages-lib/js/context/IsMobileContext.tsx';
import { PPUIGrid } from 'pricing-pages-ui-components/grid/PPUIGrid';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MerchCardLayoutUIGridRowStart = ({
  'data-test-id': dataTestId,
  'data-selenium-id': dataSeleniumId,
  columnStart,
  Title,
  Subheading,
  Pricing,
  Seats,
  Term,
  Subtext,
  CTAs,
  Features,
  Footer
}) => {
  const isMobile = useIsMobile();
  const gridItemProps = {
    gridColumnStart: columnStart,
    paddingInline: '700',
    showBorderLeft: true,
    showBorderRight: true
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridRowStart: 1,
      paddingBlockStart: "800",
      position: "relative",
      showBorderTop: isMobile,
      "data-selenium-id": dataSeleniumId,
      "data-test-id": `${dataTestId}-top`,
      "data-mobile-border": isMobile ? 'top' : undefined
    }, gridItemProps, {
      children: Title
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridRowStart: 2,
      paddingBlockStart: "0"
    }, gridItemProps, {
      children: Subheading
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridRowStart: 3,
      paddingBlockStart: "400"
    }, gridItemProps, {
      children: Pricing
    })), Seats && /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridRowStart: 4,
      paddingBlockStart: "400"
    }, gridItemProps, {
      children: Seats
    })), Term && /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridRowStart: 5,
      paddingBlockStart: "400"
    }, gridItemProps, {
      children: Term
    })), Subtext && /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridRowStart: 6,
      paddingBlockStart: "600"
    }, gridItemProps, {
      children: Subtext
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridRowStart: 7,
      paddingBlockStart: "600"
    }, gridItemProps, {
      children: CTAs
    })), /*#__PURE__*/_jsx(PPUIGrid, Object.assign({
      paddingBlockStart: "800",
      gridRowStart: 8,
      gridRowEnd: 10,
      gridTemplateRows: "subgrid"
    }, gridItemProps, {
      children: Features
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridRowStart: 11,
      paddingBlockStart: "400",
      paddingBlockEnd: "600",
      showBorderBottom: isMobile,
      "data-test-id": `${dataTestId}-bottom`,
      "data-selenium-id": `${dataSeleniumId}-bottom`,
      "data-mobile-border": isMobile ? 'bottom' : undefined
    }, gridItemProps, {
      children: Footer
    }))]
  });
};